// EXACT COPY of app/Support/BiomarkerCategoryLabels.php::RU + ::SORT_ORDER.
// Source of truth — backend (`DashboardCategory.category_label_ru` / `BiomarkerListItem.category_label_ru`).
// Этот файл — defensive fallback + sort для случаев, когда backend label отсутствует
// (extras / unknown code). При изменении backend констант — обновить здесь + T-S5-12b sync-test упадёт.
//
// Source of truth: docs/specs/sprint-5/stage-4-frontend.md §4.5.

import type { CategoryCode } from '@/api/types';

export const LABELS_RU: Record<CategoryCode, string> = {
  cbc: 'Кровь (ОАК)',
  biochemistry: 'Биохимия',
  hormones: 'Гормоны',
  sex_hormones: 'Половые гормоны',
  vitamins_minerals: 'Витамины и минералы',
  inflammation: 'Воспаление',
  urinalysis: 'Моча',
  // v2 мастер-каталог (2026-07): расширение до 18 систем тела.
  metabolism: 'Обмен веществ',
  lipids: 'Липидный профиль',
  tumor_markers: 'Онкомаркеры',
  hemostasis: 'Гемостаз',
  infections: 'Инфекции',
  electrolytes: 'Электролиты',
  gastro: 'ЖКТ',
  cardiac: 'Кардиомаркеры',
  pulmonary: 'Лёгкие',
  immunity: 'Иммунитет',
  muscle: 'Мышцы',
  female_reproductive: 'Женская репродуктивная система',
  male_reproductive: 'Мужская репродуктивная система',
};

export const SORT_ORDER: Record<CategoryCode, number> = {
  cbc: 10,
  biochemistry: 20,
  hormones: 30,
  sex_hormones: 40,
  vitamins_minerals: 50,
  inflammation: 60,
  urinalysis: 70,
  metabolism: 80,
  lipids: 90,
  tumor_markers: 100,
  hemostasis: 110,
  infections: 120,
  electrolytes: 130,
  gastro: 140,
  cardiac: 150,
  pulmonary: 160,
  immunity: 170,
  muscle: 180,
  female_reproductive: 185,
  male_reproductive: 190,
};

export function categoryLabelFor(code: string): string {
  return LABELS_RU[code as CategoryCode] ?? code;
}

export function categorySortOrder(code: string): number {
  return SORT_ORDER[code as CategoryCode] ?? 999;
}
